import { useEffect, useState } from 'react';
import { API } from './siteConfig';

// Trial terms mirror the checkout flow (SubscriptionCardSelection + backend trial_days=7).
export const TRIAL_DAYS = 7;
export const CANCEL_ANYTIME = true;

export const TRIAL_PLAN = {
  name: 'Free Trial',
  price: '$0',
  period: `for ${TRIAL_DAYS} days`,
  features: [
    'Full workspace access during the trial',
    'AI Search outlooks with charts and key levels',
    'Options flow board and Daily Market Snapshot',
    'Watchlists and alerts',
  ],
  note: `A payment card is required to start. Billing begins on day ${TRIAL_DAYS + 1} unless you cancel.`,
};

// Pro prices and features come from /api/subscription-plans, the same config checkout charges against.
export const usePlans = () => {
  const [state, setState] = useState({ status: 'loading' });
  useEffect(() => {
    let alive = true;
    fetch(`${API}/api/subscription-plans`)
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then(({ plans }) => {
        const pro = plans.filter((p) => p.plan_type === 'pro');
        const monthly = pro.find((p) => p.billing_period === 'monthly');
        const yearly = pro.find((p) => p.billing_period === 'yearly');
        if (alive) setState(monthly ? { status: 'ready', monthly, yearly, features: monthly.features } : { status: 'error' });
      })
      .catch(() => alive && setState({ status: 'error' }));
    return () => { alive = false; };
  }, []);
  return state;
};

export const money = (v) => `$${Number(v).toFixed(2)}`;
